import React from 'react';
import DestinationTemplate from '../../components/DestinationTemplate';

const JapanPage = () => {
  return <DestinationTemplate destinationId="japan" />;
};

export default JapanPage;
